// ═══════════════════════════════════════════════════════════════════
//  modules/chat/SujRunsModal.js
//  SujRunsModal
// ═══════════════════════════════════════════════════════════════════

import { useEffect, useState } from "react";
import { Badge } from "../../composants/Badge";
import { API_BASE } from "../../socle/api";
import { THEME } from "../../socle/theme";
import { SUJ_CANAUX } from "./constantes";
import { sujDateLongue } from "./utils";

// ── Modale : historique des passages ──────────────────────────────────
export function SujRunsModal({ token, canal, onClose }) {
  const [runs, setRuns] = useState(null);
  const [fenetre, setFenetre] = useState(6);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/chat/analysis/runs?canal=${canal}&limit=60`, { headers: { Authorization: `Bearer ${token}` } });
        const data = await res.json();
        setRuns(Array.isArray(data.runs) ? data.runs : []);
        if (data.fenetre_heures) setFenetre(data.fenetre_heures);
      } catch { setRuns([]); }
    };
    load();
  }, [canal, token]);

  const badge = (s) => s === "success" ? { t: "SUCCESS", c: THEME.emerald, b: THEME.emeraldDim }
    : s === "empty" ? { t: "VIDE", c: THEME.textMuted, b: THEME.surface }
    : { t: "ERREUR", c: THEME.red, b: THEME.redDim };

  return (
    <div onClick={(e) => e.target === e.currentTarget && onClose()}
      style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.65)", zIndex: 1000, display: "flex", alignItems: "flex-start", justifyContent: "center", padding: 24, overflowY: "auto" }}>
      <div style={{ background: THEME.bg, border: `1px solid ${THEME.border}`, borderRadius: 16, width: "100%", maxWidth: 800, padding: 22 }}>
        <div style={{ display: "flex", alignItems: "center", marginBottom: 6 }}>
          <div style={{ color: THEME.gold, fontSize: 17, fontWeight: 800 }}>🕒 Historique des passages</div>
          <button onClick={onClose} style={{ marginLeft: "auto", background: "none", border: "none", color: THEME.textMuted, fontSize: 22, cursor: "pointer", lineHeight: 1 }}>×</button>
        </div>
        <div style={{ color: THEME.textMuted, fontSize: 12, marginBottom: 16 }}>
          Un passage par fenêtre de {fenetre} h sur le canal « {(SUJ_CANAUX.find((c) => c.id === canal) || {}).label} ».
        </div>

        {runs === null && <div style={{ color: THEME.textDim, fontSize: 13 }}>Chargement…</div>}
        {runs && runs.length === 0 && <div style={{ color: THEME.textDim, fontSize: 13 }}>Aucun passage enregistré pour ce canal.</div>}
        {runs && runs.map((r) => {
          const b = badge(r.status);
          return (
            <div key={r.id} style={{ background: THEME.panel, border: `1px solid ${THEME.border}`, borderRadius: 10, padding: "10px 14px", marginBottom: 8 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap", marginBottom: r.resume || r.erreur ? 6 : 0 }}>
                <span style={{ color: THEME.text, fontSize: 13, fontWeight: 700 }}>{sujDateLongue(r.window_start)}</span>
                <span style={{ color: THEME.textDim, fontSize: 11 }}>→ {new Date(r.window_end).toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" })}</span>
                <Badge text={b.t} bg={b.b} color={b.c} />
                <span style={{ color: THEME.textMuted, fontSize: 11 }}>
                  {r.nb_messages} msg{r.nb_lots > 1 ? ` · ${r.nb_lots} lots` : ""}
                </span>
                {r.nb_messages > 0 && r.nb_messages_analyses != null && r.nb_messages_analyses < r.nb_messages && (
                  <Badge text={`⚠ ${r.nb_messages_analyses}/${r.nb_messages} analysés`} bg={THEME.amberDim} color={THEME.amber} />
                )}
                {r.nb_sujets_nouveaux > 0 && <Badge text={`+${r.nb_sujets_nouveaux} sujet(s)`} bg={THEME.purpleDim} color={THEME.purple} />}
                {r.nb_sujets_maj > 0 && <Badge text={`${r.nb_sujets_maj} maj`} bg={THEME.accentDim} color={THEME.accent} />}
                {r.nb_taches_creees > 0 && <Badge text={`📋 ${r.nb_taches_creees} tâche(s)`} bg={THEME.emeraldDim} color={THEME.emerald} />}
                {r.nb_taches_majs > 0 && <Badge text={`📋 ${r.nb_taches_majs} maj`} bg={THEME.goldDim} color={THEME.gold} />}
                <span style={{ marginLeft: "auto", color: THEME.textDim, fontSize: 10 }}>
                  {r.duree_ms != null && `${(r.duree_ms / 1000).toFixed(1)} s`}{r.triggered_by && r.triggered_by !== "planificateur" ? ` · ${r.triggered_by}` : ""}
                </span>
              </div>
              {r.resume && <div style={{ color: THEME.textMuted, fontSize: 12, lineHeight: 1.45 }}>{r.resume}</div>}
              {r.erreur && <div style={{ color: THEME.red, fontSize: 12 }}>{r.erreur}</div>}
            </div>
          );
        })}
      </div>
    </div>
  );
}
